import axios from 'axios';

export function findPIClubs(text) {
    return axios({
        method: 'post',
        url: '/api/v1/pi-club/find',
        data: {
            query: text,
        },
        withCredentials: true,
    });
}

export function addPIClub(text) {
    return axios({
        method: 'post',
        url: '/api/vi/pi-club/save',
        data: {
            query: text,
        },
        withCredentials: true,
    });
}

export function getPIClubById() {
    return axios({
        method: 'get',
        url: '/api/v1/pi-club',
        withCredentials: true,
    })
        .then(response => response.data)
        .catch(response => response.data);
}



// WEBPACK FOOTER //
// ./app/services/piClubs.js